// =============================================================================
// SALES PAGES LAYOUTS
// =============================================================================

import {isMobile} from '@/prototypes/u/other'

export default {
  path: 'sales',
  component: () => import('../../views/admin/sales/index.vue'),
  children: [
    {
      path: '',
      redirect: '/error-404'
    },
    {
      path: 'invoices',
      component: () => import('../../views/admin/sales/invoices/index.vue'),
      children: [
        {
          path: '',
          name: 'saleInvoices',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileSaleInvoices" */ '@/mobile/views/admin/sales/invoices/list/saleInvoicesList.vue') : import(/* webpackChunkName: "desktopSaleInvoices" */ '@/desktop/views/admin/sales/invoices/list/saleInvoicesList.vue') },
          meta: {
            permission: 'sale_invoice.show',
            pageTitle: '',
            pageTitleI18n: 'pages.sales.invoices.list.title'
          // rule: 'editor'
          }
        },
        {
          path: 'trash',
          name: 'saleInvoiceTrash',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileSaleTrash" */ '@/mobile/views/admin/sales/invoices/trash/saleInvoicesTrash.vue') : import(/* webpackChunkName: "desktopSaleTrash" */ '@/desktop/views/admin/sales/invoices/trash/saleInvoicesTrash.vue') },
          meta: {
            permission: 'sale_invoice.delete',
            pageTitle: 'سطل زباله فاکتور فروش',
            pageTitleI18n: 'pages.sales.invoices.trash.title'
          // rule: 'editor'
          }
        },
        {
          path: 'trash/:id',
          name: 'saleInvoiceTrashProfile',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileSaleInvoiceTrash" */ '@/mobile/views/admin/sales/invoices/invoice/saleInvoice.vue') : import(/* webpackChunkName: "desktopSaleInvoiceTrash" */ '@/desktop/views/admin/sales/invoices/invoice/saleInvoice.vue') },
          meta: {
            permission: 'sale_invoice.show',
            pageTitle: '',
            pageTitleI18n: 'pages.sales.invoices.invoice.title',
            redirectNotFound: true
          // rule: 'editor'
          }
        },
        {
          path: 'insert',
          name: 'insertSaleInvoice',
          component: () => import(/* webpackChunkName: "insertSaleInvoice" */ '../../views/admin/sales/invoices/insert/insertSaleInvoice.vue'),
          meta: {
            permission: 'sale_invoice.create',
            pageTitle: '',
            pageTitleI18n: 'pages.sales.invoices.insert.title'
          // rule: 'editor'
          }
        },

        {
          path: ':id',
          component: () => import('../../views/admin/sales/invoices/invoice/index'),
          meta: {
            redirectNotFound: true
          },
          children: [
            {
              path: '',
              name: 'saleInvoice',
              component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileSaleInvoice" */ '@/mobile/views/admin/sales/invoices/invoice/saleInvoice.vue') : import(/* webpackChunkName: "desktopSaleInvoice" */ '@/desktop/views/admin/sales/invoices/invoice/saleInvoice.vue') },
              meta: {
                permission: 'sale_invoice.show',
                pageTitle: '',
                pageTitleI18n: 'pages.sales.invoices.invoice.title'
              // rule: 'editor'
              }
            },
            {
              path: 'activities-log',
              name: 'saleInvoiceActivitiesLog',
              component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileSaleInvoiceActivitiesLog" */ '@/mobile/views/admin/sales/invoices/activitiesLog/saleInvoiceActivitiesLog.vue') : import(/* webpackChunkName: "desktopSaleInvoiceActivitiesLog" */ '@/desktop/views/admin/sales/invoices/activitiesLog/saleInvoiceActivitiesLog.vue') },
              meta: {
                permission: 'activity_logs.show',
                pageTitle: 'لاگ های فاکتور فروش',
                pageTitleI18n: 'pages.sales.invoices.invoice.logs.title'
              // rule: 'editor'
              }
            },
            {
              path: 'edit',
              name: 'editSaleInvoice',
              component: () => import(/* webpackChunkName: "editSaleInvoice" */ '../../views/admin/sales/invoices/edit/editSaleInvoice.vue'),
              meta: {
                permission: 'sale_invoice.update',
                pageTitle: '',
                pageTitleI18n: 'pages.sales.invoices.edit.title'
              // rule: 'editor'
              }
            },
            {
              path: 'return',
              name: 'insertReturnSaleInvoice',
              component: () => import(/* webpackChunkName: "insertReturnSaleInvoice" */ '../../views/admin/sales/returnInvoices/insert/insertReturnSaleInvoice.vue'),
              meta: {
                permission: ['sale_invoice.show', 'sale_invoice.update', 'return_sale_invoice.create'],
                pageTitle: '',
                pageTitleI18n: 'pages.sales.returnInvoices.insert.title'
              // rule: 'editor'
              }
            }
          ]
        }
      ]
    },
    {
      path: 'gifts',
      component: () => import('../../views/admin/sales/invoices/giftIndex.vue'),
      children: [
        {
          path: '',
          name: 'giftInvoices',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileGiftInvoices" */ '@/mobile/views/admin/sales/invoices/list/saleInvoicesList.vue') : import(/* webpackChunkName: "desktopGiftInvoices" */ '@/desktop/views/admin/sales/invoices/list/saleInvoicesList.vue') },
          meta: {
            permission: 'sale_invoice.show',
            pageTitle: '',
            pageTitleI18n: 'pages.sales.gifts.list.title'
          // rule: 'editor'
          }
        },
        {
          path: 'trash',
          name: 'giftInvoiceTrash',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileGiftTrash" */ '@/mobile/views/admin/sales/invoices/trash/saleInvoicesTrash.vue') : import(/* webpackChunkName: "desktopGiftTrash" */ '@/desktop/views/admin/sales/invoices/trash/saleInvoicesTrash.vue') },
          meta: {
            permission: 'sale_invoice.delete',
            pageTitle: 'سطل زباله فاکتور فروش',
            pageTitleI18n: 'pages.sales.gifts.trash.title'
          // rule: 'editor'
          }
        },
        {
          path: 'trash/:id',
          name: 'giftInvoiceTrashProfile',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileGiftInvoiceTrashProfile" */ '@/mobile/views/admin/sales/invoices/invoice/saleInvoice.vue') : import(/* webpackChunkName: "desktopGiftInvoiceTrashProfile" */ '@/desktop/views/admin/sales/invoices/invoice/saleInvoice.vue') },
          meta: {
            permission: 'sale_invoice.show',
            pageTitle: '',
            pageTitleI18n: 'pages.sales.gifts.invoice.title',
            redirectNotFound: true
          // rule: 'editor'
          }
        },
        {
          path: 'insert',
          name: 'insertGiftInvoice',
          component: () => import(/* webpackChunkName: "insertGiftInvoice" */ '../../views/admin/sales/invoices/insert/insertSaleInvoice.vue'),
          meta: {
            permission: 'sale_invoice.create',
            pageTitle: '',
            pageTitleI18n: 'pages.sales.gifts.insert.title'
          // rule: 'editor'
          }
        },
        {
          path: ':id',
          component: () => import('../../views/admin/sales/invoices/invoice/index'),
          meta: {
            redirectNotFound: true
          },
          children: [
            {
              path: '',
              name: 'giftInvoice',
              component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileGiftInvoice" */ '@/mobile/views/admin/sales/invoices/invoice/saleInvoice.vue') : import(/* webpackChunkName: "desktopGiftInvoice" */ '@/desktop/views/admin/sales/invoices/invoice/saleInvoice.vue') },
              meta: {
                permission: 'sale_invoice.show',
                pageTitle: '',
                pageTitleI18n: 'pages.sales.gifts.invoice.title'
              // rule: 'editor'
              }
            },
            {
              path: 'activities-log',
              name: 'giftInvoiceActivitiesLog',
              component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileGiftInvoiceActivitiesLog" */ '@/mobile/views/admin/sales/invoices/activitiesLog/saleInvoiceActivitiesLog.vue') : import(/* webpackChunkName: "desktopGiftInvoiceActivitiesLog" */ '@/desktop/views/admin/sales/invoices/activitiesLog/saleInvoiceActivitiesLog.vue') },
              meta: {
                permission: 'activity_logs.show',
                pageTitle: 'لاگ های فاکتور فروش',
                pageTitleI18n: 'pages.sales.gifts.invoice.logs.title'
              // rule: 'editor'
              }
            },
            {
              path: 'edit',
              name: 'editGiftInvoice',
              component: () => import(/* webpackChunkName: "editGiftInvoice" */ '../../views/admin/sales/invoices/edit/editSaleInvoice.vue'),
              meta: {
                permission: 'sale_invoice.update',
                pageTitle: '',
                pageTitleI18n: 'pages.sales.gifts.edit.title'
              // rule: 'editor'
              }
            },
            {
              path: 'return',
              name: 'insertReturnGiftInvoice',
              component: () => import(/* webpackChunkName: "insertReturnGiftInvoice" */ '../../views/admin/sales/returnInvoices/insert/insertReturnSaleInvoice.vue'),
              meta: {
                permission: ['sale_invoice.show', 'sale_invoice.update', 'return_sale_invoice.create'],
                pageTitle: '',
                pageTitleI18n: 'pages.sales.returnInvoices.insert.title'
              // rule: 'editor'
              }
            }
          ]
        }
      ]
    },
    {
      path: 'return-invoices',
      component: () => import('../../views/admin/sales/returnInvoices/index.vue'),
      children: [
        {
          path: '',
          name: 'returnSaleInvoices',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileReturnSaleInvoices" */ '@/mobile/views/admin/sales/returnInvoices/list/returnSaleInvoicesList.vue') : import(/* webpackChunkName: "desktopReturnSaleInvoices" */ '@/desktop/views/admin/sales/returnInvoices/list/returnSaleInvoicesList.vue') },
          meta: {
            permission: 'return_sale_invoice.show',
            pageTitle: '',
            pageTitleI18n: 'pages.sales.returnInvoices.list.title'
          // rule: 'editor'
          }
        },
        {
          path: 'trash',
          name: 'returnSaleInvoicesTrash',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileReturnSaleInvoiceTrash" */ '@/mobile/views/admin/sales/returnInvoices/trash/returnSaleInvoicesTrash.vue') : import(/* webpackChunkName: "desktopReturnSaleInvoiceTrash" */ '@/desktop/views/admin/sales/returnInvoices/trash/returnSaleInvoicesTrash.vue') },
          meta: {
            permission: 'return_sale_invoice.delete',
            pageTitle: '',
            pageTitleI18n: 'pages.sales.returnInvoices.trash.title'
          // rule: 'editor'
          }
        },
        {
          path: 'trash/:id',
          name: 'returnSaleInvoiceTrashProfile',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileReturnSaleInvoiceTrashProfile" */ '@/mobile/views/admin/sales/returnInvoices/invoice/returnSaleInvoice.vue') : import(/* webpackChunkName: "desktopReturnSaleInvoiceTrashProfile" */ '@/desktop/views/admin/sales/returnInvoices/invoice/returnSaleInvoice.vue') },
          meta: {
            permission: 'return_sale_invoice.show',
            pageTitle: '',
            pageTitleI18n: 'pages.sales.returnInvoices.invoice.title',
            redirectNotFound: true
          // rule: 'editor'
          }
        },
        {
          path: ':id',
          name: 'returnSaleInvoice',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileReturnSaleInvoice" */ '@/mobile/views/admin/sales/returnInvoices/invoice/returnSaleInvoice.vue') : import(/* webpackChunkName: "desktopReturnSaleInvoice" */ '@/desktop/views/admin/sales/returnInvoices/invoice/returnSaleInvoice.vue') },
          meta: {
            permission: 'return_sale_invoice.show',
            pageTitle: '',
            pageTitleI18n: 'pages.sales.returnInvoices.invoice.title',
            redirectNotFound: true
          // rule: 'editor'
          }
        },
        {
          path: ':id/activities-log',
          name: 'returnSaleInvoiceActivitiesLog',
          component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileReturnSaleInvoiceActivitiesLog" */ '@/mobile/views/admin/sales/returnInvoices/activitiesLog/returnSaleInvoiceActivitiesLog.vue') : import(/* webpackChunkName: "desktopReturnSaleInvoiceActivitiesLog" */ '@/desktop/views/admin/sales/returnInvoices/activitiesLog/returnSaleInvoiceActivitiesLog.vue') },
          meta: {
            permission: 'activity_logs.show',
            pageTitle: 'لاگ های فاکتور مرجوع فروش',
            pageTitleI18n: 'pages.sales.returnInvoices.invoice.logs.title',
            redirectNotFound: true
          // rule: 'editor'
          }
        },
        {
          path: ':id/edit',
          name: 'editReturnSaleInvoice',
          component: () => import(/* webpackChunkName: "editReturnSaleInvoice" */ '../../views/admin/sales/returnInvoices/edit/editReturnSaleInvoice.vue'),
          meta: {
            permission: 'return_sale_invoice.update',
            pageTitle: '',
            pageTitleI18n: 'pages.sales.returnInvoices.edit.title',
            redirectNotFound: true
          // rule: 'editor'
          }
        }
      ]
    },
    {
      path: 'pricing',
      component: () => { return isMobile() ?  import(/* webpackChunkName: "mobilePricing" */ '@/mobile/views/admin/sales/productPricing/productPricing.vue') : import(/* webpackChunkName: "desktopPricing" */ '@/desktop/views/admin/sales/productPricing/productPricing.vue') },
      name: 'productsPricing',
      meta: {
        pageTitle: 'قیمت گذاری محصولات',
        pageTitleI18n: 'pages.sales.pricing.title'
      // rule: 'editor'
      }
    },
    {
      path: 'sales-flow',
      component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileSalesFlowProducts" */ '@/mobile/views/admin/sales/salesFlowProducts/salesFlowProductsList.vue') : import(/* webpackChunkName: "desktopSalesFlowProducts" */ '@/desktop/views/admin/sales/salesFlowProducts/salesFlowProductsList.vue') },
      name: 'salesFlowProducts',
      meta: {
        permission: 'sale_flow_products.show',
        pageTitle: '',
        pageTitleI18n: 'pages.sales.saleFlowProducts.list.title'
        // rule: 'editor'
      }
    },
    {
      path: 'suggest',
      name: 'suggestSaleInvoice',
      component: () => { return isMobile() ?  import(/* webpackChunkName: "mobileSuggestSaleInvoice" */ '@/mobile/views/admin/sales/suggest/saleSuggest.vue') : import(/* webpackChunkName: "desktopSuggestSaleInvoice" */ '@/desktop/views/admin/sales/suggest/saleSuggest.vue') },
      meta: {
        permission: 'suggest_sale_invoice.show',
        pageTitle: 'پیشنهاد فروش',
        pageTitleI18n: 'pages.sales.suggest.title'
        // rule: 'editor'
      }
    }
    /*{
      path: 'groups',
      component: () => import('../../views/admin/sales/groups/index'),
      children: [
        {
          path: '',
          name: 'saleGroupsList',
          component: () => import(/!* webpackChunkName: "saleGroupsList" *!/ '../../views/admin/sales/groups/list/saleGroupsList.vue'),
          meta: {
            pageTitle: 'لیست گروه های فروش',
            pageTitleI18n: 'pages.sales.groups.list.title'
          // rule: 'editor'
          }
        },
        {
          path: 'insert',
          name: 'insertSaleGroup',
          component: () => import(/!* webpackChunkName: "insertSaleGroup" *!/ '../../views/admin/sales/groups/insert/insertSaleGroup.vue'),
          meta: {
            pageTitle: 'افزودن گروه فروش جدید',
            pageTitleI18n: 'pages.sales.groups.insert.title'
          // rule: 'editor'
          }
        },
        {
          path: 'grp-:id/edit',
          name: 'editSaleGroup',
          component: () => import(/!* webpackChunkName: "editSaleGroup" *!/ '../../views/admin/sales/groups/edit/editSaleGroup.vue'),
          meta: {
            pageTitle: 'ویرایش گروه فروش',
            pageTitleI18n: 'pages.sales.groups.edit.title'
          // rule: 'editor'
          }
        }
      ]
    }*/
  ]
}
